export default {
  surtitle: {
    id: 'listings_no_offers_surtitle',
    defaultMessage: "Is it me you're looking for?",
  },
  titleActive: {
    id: 'listings_no_offers_title_active',
    defaultMessage: "There's no active listings",
  },
  descriptionActive: {
    id: 'listings_no_offers_description_active',
    defaultMessage:
      "It looks like you currently don't have active listings but you have some with missing information, in validation or archived. You can access them through the tab navigation on top of the page.",
  },
  titleMissingInfos: {
    id: 'listings_no_offers_title_missing_information',
    defaultMessage: "There's no listings with missing information",
  },
  descriptionMissingInfos: {
    id: 'listings_no_offers_description_missing_information',
    defaultMessage:
      "It looks like you currently don't have listings with missing information but you have some actives, in validation or archived. You can access them through the tab navigation on top of the page.",
  },
  titleInValidation: {
    id: 'listings_no_offers_title_in_validation',
    defaultMessage: "There's no listings in validation",
  },
  descriptionInValidation: {
    id: 'listings_no_offers_description_in_validation',
    defaultMessage:
      "It looks like you currently don't have listings in validation but you have some actives, missing information or archived. You can access them through the tab navigation on top of the page.",
  },
  titleArchived: {
    id: 'listings_no_offers_title_archived',
    defaultMessage: "There's no archived listings",
  },
  descriptionArchived: {
    id: 'listings_no_offers_description_archived',
    defaultMessage:
      "It looks like you currently don't have archived listings but you have some actives, missing information or in validations. You can access them through the tab navigation on top of the page.",
  },
}
